import React, { useState, useEffect } from "react";
import styles from "./Popup.module.css";
import Button from "../../../components/Button";
import GameResult from "../GameResult";
import useTranslation from "next-translate/useTranslation";
import { StatusTypes } from "@chesshotel/constants";
import { ResultTypes } from "@chesshotel/constants";

export default function PracticeGamePopup({
  onClose,
  result,
  status,
  playingWhite,
  opponentName,
}) {
  const { t } = useTranslation("common");
  const [visible, setVisible] = useState("hidden");

  const gameResultProps = { playingWhite, result, status, opponentName };

  useEffect(() => {
    setVisible("show");
  }, []);

  const hide = () => {
    setVisible("hide");
    setTimeout(() => {
      onClose();
    }, 600);
  };

  let resultText: string;
  if (result === ResultTypes.WHITE_WINNS) {
    resultText = t("White wins") + "!";
  } else if (result === ResultTypes.BLACK_WINNS) {
    resultText = t("Black wins") + "!";
  } else if (status === StatusTypes.ABORT) {
    resultText = t("Game aborted");
  } else {
    resultText = t("Draw");
  }

  return (
    <div className={styles.cont + " " + styles[visible]}>
      <div className={styles.overlay} onClick={hide}></div>
      <div className={styles.popup}>
        {onClose && (
          <div className={styles.close} onClick={hide}>
            ×
          </div>
        )}
        <div className={styles.title}>{resultText}</div>
        {status !== StatusTypes.ABORT && (
          <div className="flex flex-col items-center p-7">
            <GameResult {...gameResultProps} />
          </div>
        )}
        <div className={styles.buttonsCont}>
          <Button onClick={hide} color="white" size="medium">
            {t("Close")}
          </Button>
        </div>
      </div>
    </div>
  );
}
